import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Section from '../../../componentsv2/Section';
import Typography from '../../../componentsv2/Typography';
import NumericText from '../../../componentsv2/NumericText';
import { useTranslation } from '../../../hooks/i18n';
import { formatDateTime } from '../../../utils/common';

export default function TotalBalanceCard({
  totalBalance,
  isLoading,
}: {
  totalBalance?: number;
  isLoading?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <Section
      sx={{
        background: '#fff',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        padding: '2em',
        flex: 1,
        boxSizing: 'border-box',
      }}
    >
      {isLoading ? (
        <>
          <Skeleton variant="text" width={100} sx={{ fontSize: '16px' }} animation="wave" />
          <Skeleton
            variant="rectangular"
            height={40}
            width={200}
            animation="wave"
            sx={{ borderRadius: '8px' }}
          />
          <Skeleton variant="text" width={160} sx={{ fontSize: '12px' }} animation="wave" />
        </>
      ) : (
        <>
          <Typography sx={{ fontSize: '16px', fontWeight: 500 }}>
            {t('banking-page:dashboard.totalBalance')}
          </Typography>
          <Box>
            <NumericText
              digits={2}
              currency="USD"
              sx={{ fontSize: '34px', fontWeight: 700, color: '#1C2B4A', lineHeight: 1.1 }}
            >
              {totalBalance || 0}
            </NumericText>
          </Box>
          <Typography sx={{ fontSize: '12px', color: '#91A2BB' }}>
            {t('banking-page:dashboard.estimatedBalance')} {formatDateTime(new Date())}
          </Typography>
        </>
      )}
    </Section>
  );
}
